module.exports = __webpack_public_path__ + "img/case2.bace6cf0.png";